import './src/bundles/styles/Styles.css'
import './src/scss/global.scss'